import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Logo,loader_image } from  "../_components/Imagepath";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";

import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import $ from "jquery";




const CustomerInvoicePaymentDetails = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [apiData, setApiData] = useState([]);

  const [currencySymbol, setCurrencySymbol] = useState('');
  
  let season_id = localStorage.getItem("season_id");
  useEffect(() => {
    axios
      .get(`/customerportal/invoices/view/${id+'-'+season_id+'-portal_user'}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.invoice);
          axios.get(`/helper/currency-by-order/${response.data.data.invoice.order}`, {
            headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
            // console.log(response.data.data);
              setCurrencySymbol(response.data.data.customer_currency)
            
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });


      axios
      .get(`/invoices/view-download/${id+'-'+season_id}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          
          setApiData(response.data.data.invoice);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  console.log(apiData);

  
  const handleDownloadPDF = async (value) => {
    var invoice_id = value.id;

    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    axios.get(`/customerportal/invoices/finance-sale-invoice/${invoice_id+'-'+season_id}`, {
       responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
   }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name = value.invoice_number +'.pdf';
        link.download = file_name;
        link.click();
        $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
    });
};
  

const handleDownloadPDFPackagingList = async (value) => {

  $("#loader-image-invoice2").removeClass('loader-hide');
  $("#loader-image-invoice").addClass('loader-show');
  var invoice_id = value.id;
  axios.get(`/customerportal/invoices/view-download-pdf/${invoice_id+'-'+season_id}`, {
     responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
 }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
     let file_name = value.invoice_number +'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image-invoice2").addClass('loader-hide');
      $("#loader-image-invoice2").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });
};

    return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-10">
                  <h3 className="page-title">View Invoice</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/customerportal/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/invoices-payments">Invoices and Payments</Link>
                    </li>
                    <li className="breadcrumb-item active">View Invoice</li>
                  </ul>
                </div>
                <div className="col-sm-2">
                <div className="pull-right">

                  {value.packaging_list_id !=0 &&(
                        <button   onClick={() => handleDownloadPDFPackagingList(value)}   className="btn btn-primary me-1"  > Download Invoice  <i className="fa fa-download" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image}/>  </button>
                
                  )}

                {value.packaging_list_id ==0 &&(
                        <button   onClick={() => handleDownloadPDF(value)}   className="btn btn-primary me-1"  >  Download Sale Invoice  <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                
                  )}

                  
                     
                    </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-12"  id="printablediv">
                <div className="card"   style={{width:'100%'}}  >
                  <div className="card-body">
                    <div className="invoice-item">
                      <div className="row">
                        
                       
                      </div>
                    </div>

                    <div className="invoice-item">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="invoice-info">
                            <div className="invoice-logo-">
                             <img src={Logo} alt="logo" style={{width: "100px", height:'110px'}} />
                            </div>
                            <strong className="customer-text">
                              Invoice From
                            </strong>
                            <p className="invoice-details invoice-details-two">
                               EXPORT OPTIMUM
                              <br /> DOUAR MOUARAA TEYARA <br />
                              LAAOUAMRA KSAR EL KEBIR

                              <br />
                              Phone: 00212678732391 <br />
                             
                             
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="invoice-info invoice-info2">
                             <p className="invoice-details text-center">
                                <strong>Invoice N°:</strong> {value.invoice_number}{" "}
                                <br />
                                <strong>Date:</strong> {value.date}
                            </p>
                            <strong className="customer-text text-center">
                              Invoice To
                            </strong>
                            <p className="invoice-details">
                              {value.customer_id
                                ? value.customer.company_name
                                : ""}
                              <br />
                              {value.invoicing_address
                                ? value.invoice_address.email
                                : ""}
                              <br />
                              {value.invoicing_address
                                ? value.invoice_address.phone_number
                                : ""}
                              <br />
                              {value.invoicing_address
                                ? value.invoice_address.address
                                : ""}
                              <br />
                              {value.invoicing_address
                                ? value.invoice_address.city
                                : ""}
                              <br />
                              {value.invoicing_address
                                ? value.invoice_address.zip_code
                                : ""}
                              <br />
                        
                              Incoterms:{" "}
                              {value.customer && value.customer.incoterm_name
                                ? value.customer.incoterm_name.title
                                : ""}
                             ,
                              Payment Terms:{" "}
                              {value.customer && value.customer.payment_term
                                ? value.customer.payment_terms
                                    .delay1_description
                                : ""}
                              <br />
                              Country of Origin:{" "}
                              {value.invoicing_address
                                ? value.invoice_address.country_name
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="invoice-item invoice-table-wrap">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="invoice-table table table-bordered">
                              <thead>
                                <tr>
                                  <th>Code</th>
                                  <th>Product</th>
                                  {/* <th>Calibre</th> */}
                                  <th className="text-center">Quantity (kg)</th>
                                  <th className="text-end">Price (Euro/Kg)</th>
                                  <th className="text-end">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {value.items &&
                                  value.items.map((item) => (
                                    <tr key={item.id}>
                                      <td>  {item.product_type_category
                                        ? item.product_type_category.code
                                        : ""}
                                    </td>
                                      <td>
                                      {item.product_type_category
                                        ? item.product_type_category.product_name
                                        : ""} {item.calibre}


                                      </td>

                                      <td className="text-center">
                                        {item.quantity}
                                      </td>
                                      <td className="text-end">{item.price}{currencySymbol}</td>
                                      <td className="text-end">
                                        {item.amount}{currencySymbol}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-6 col-xl-4 ms-auto">
                          <div className="table-responsive">
                            <table className="invoice-table-two table">
                              <tbody>
                                <tr>
                                  <th>Tax:</th>
                                  <td>
                                    <span>0{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Discount:</th>
                                  <td>
                                    <span>0{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Final Amount:</th>
                                  <td>
                                    <span>{value.total_amount}{currencySymbol}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerInvoicePaymentDetails;
